(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7592,1555,867,2901],{

/***/ 51555:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*! @name videojs-contrib-quality-levels @version 4.1.0 @license Apache-2.0 */
(function (global, factory) {
   true ? module.exports = factory(__webpack_require__(21838)) :
  0;
})(this, (function (videojs) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var videojs__default = /*#__PURE__*/_interopDefaultLegacy(videojs);

  /**
   * A single QualityLevel.
   *
   * interface QualityLevel {
   *   readonly attribute DOMString id;
   *            attribute DOMString label;
   *   readonly attribute long width;
   *   readonly attribute long height;
   *   readonly attribute long bitrate;
   *            attribute boolean enabled;
   * };
   *
   * @class QualityLevel
   */
  class QualityLevel {
    /**
     * Creates a QualityLevel
     *
     * @param {Representation|Object} representation The representation of the quality level
     * @param {string}   representation.id        Unique id of the QualityLevel
     * @param {number=}  representation.width     Resolution width of the QualityLevel
     * @param {number=}  representation.height    Resolution height of the QualityLevel
     * @param {number}   representation.bandwidth Bitrate of the QualityLevel
     * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
     * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
     */
    constructor(representation) {
      let level = this; // eslint-disable-line

      level.id = representation.id;
      level.label = level.id;
      level.width = representation.width;
      level.height = representation.height;
      level.bitrate = representation.bandwidth;
      level.frameRate = representation.frameRate;
      level.enabled_ = representation.enabled;
      Object.defineProperty(level, 'enabled', {
        /**
         * Get whether the QualityLevel is enabled.
         *
         * @return {boolean} True if the QualityLevel is enabled.
         */
        get() {
          return level.enabled_();
        },
        /**
         * Enable or disable the QualityLevel.
         *
         * @param {boolean} enable true to enable QualityLevel, false to disable.
         */
        set(enable) {
          level.enabled_(enable);
        }
      });
      return level;
    }
  }

  /**
   * A list of QualityLevels.
   *
   * interface QualityLevelList : EventTarget {
   *   getter QualityLevel (unsigned long index);
   *   readonly attribute unsigned long length;
   *   readonly attribute long selectedIndex;
   *
   *   void addQualityLevel(QualityLevel qualityLevel)
   *   void removeQualityLevel(QualityLevel remove)
   *   QualityLevel? getQualityLevelById(DOMString id);
   *
   *   attribute EventHandler onchange;
   *   attribute EventHandler onaddqualitylevel;
   *   attribute EventHandler onremovequalitylevel;
   * };
   *
   * @extends videojs.EventTarget
   * @class QualityLevelList
   */
  class QualityLevelList extends videojs__default["default"].EventTarget {
    /**
     * Creates a QualityLevelList.
     */
    constructor() {
      super();
      let list = this; // eslint-disable-line

      list.levels_ = [];
      list.selectedIndex_ = -1;

      /**
       * Get the index of the currently selected QualityLevel.
       *
       * @returns {number} The index of the selected QualityLevel. -1 if none selected.
       * @readonly
       */
      Object.defineProperty(list, 'selectedIndex', {
        get() {
          return list.selectedIndex_;
        }
      });

      /**
       * Get the length of the list of QualityLevels.
       *
       * @returns {number} The length of the list.
       * @readonly
       */
      Object.defineProperty(list, 'length', {
        get() {
          return list.levels_.length;
        }
      });
      list[Symbol.iterator] = () => list.levels_.values();
      return list;
    }

    /**
     * Adds a quality level to the list.
     *
     * @param {Representation|Object} representation The representation of the quality level
     * @param {string}   representation.id        Unique id of the QualityLevel
     * @param {number=}  representation.width     Resolution width of the QualityLevel
     * @param {number=}  representation.height    Resolution height of the QualityLevel
     * @param {number}   representation.bandwidth Bitrate of the QualityLevel
     * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
     * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
     * @return {QualityLevel} the QualityLevel added to the list
     * @method addQualityLevel
     */
    addQualityLevel(representation) {
      let qualityLevel = this.getQualityLevelById(representation.id);

      // Do not add duplicate quality levels
      if (qualityLevel) {
        return qualityLevel;
      }
      const index = this.levels_.length;
      qualityLevel = new QualityLevel(representation);
      if (!('' + index in this)) {
        Object.defineProperty(this, index, {
          get() {
            return this.levels_[index];
          }
        });
      }
      this.levels_.push(qualityLevel);
      this.trigger({
        qualityLevel,
        type: 'addqualitylevel'
      });
      return qualityLevel;
    }

    /**
     * Removes a quality level from the list.
     *
     * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
     * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
     * @method removeQualityLevel
     */
    removeQualityLevel(qualityLevel) {
      let removed = null;
      for (let i = 0, l = this.length; i < l; i++) {
        if (this[i] === qualityLevel) {
          removed = this.levels_.splice(i, 1)[0];
          if (this.selectedIndex_ === i) {
            this.selectedIndex_ = -1;
          } else if (this.selectedIndex_ > i) {
            this.selectedIndex_--;
          }
          break;
        }
      }
      if (removed) {
        this.trigger({
          qualityLevel,
          type: 'removequalitylevel'
        });
      }
      return removed;
    }

    /**
     * Searches for a QualityLevel with the given id.
     *
     * @param {string} id The id of the QualityLevel to find.
     * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
     * @method getQualityLevelById
     */
    getQualityLevelById(id) {
      for (let i = 0, l = this.length; i < l; i++) {
        const level = this[i];
        if (level.id === id) {
          return level;
        }
      }
      return null;
    }

    /**
     * Resets the list of QualityLevels to empty
     *
     * @method dispose
     */
    dispose() {
      this.selectedIndex_ = -1;
      this.levels_.length = 0;
    }
  }

  /**
   * change - The selected QualityLevel has changed.
   * addqualitylevel - A QualityLevel has been added to the QualityLevelList.
   * removequalitylevel - A QualityLevel has been removed from the QualityLevelList.
   */
  QualityLevelList.prototype.allowedEvents_ = {
    change: 'change',
    addqualitylevel: 'addqualitylevel',
    removequalitylevel: 'removequalitylevel'
  };

  // emulate attribute EventHandler support to allow for feature detection
  for (const event in QualityLevelList.prototype.allowedEvents_) {
    QualityLevelList.prototype['on' + event] = null;
  }

  var version = "4.1.0";

  /**
   * Initialization function for the qualityLevels plugin. Sets up the QualityLevelList and
   * event handlers.
   *
   * @param {Player} player Player object.
   * @param {Object} options Plugin options object.
   * @return {QualityLevelList} a list of QualityLevels
   */
  const initPlugin = function (player, options) {
    const originalPluginFn = player.qualityLevels;
    const qualityLevelList = new QualityLevelList();
    const disposeHandler = function () {
      qualityLevelList.dispose();
      player.qualityLevels = originalPluginFn;
      player.off('dispose', disposeHandler);
    };
    player.on('dispose', disposeHandler);
    player.qualityLevels = () => qualityLevelList;
    player.qualityLevels.VERSION = version;
    return qualityLevelList;
  };

  /**
   * A video.js plugin.
   *
   * In the plugin function, the value of `this` is a video.js `Player`
   * instance. You cannot rely on the player being in a "ready" state here,
   * depending on how the plugin is invoked. This may or may not be important
   * to you; if not, remove the wait for "ready"!
   *
   * @param {Object} options Plugin options object
   * @return {QualityLevelList} a list of QualityLevels
   */
  const qualityLevels = function (options) {
    return initPlugin(this, videojs__default["default"].obj.merge({}, options));
  };

  // Register the plugin with video.js.
  videojs__default["default"].registerPlugin('qualityLevels', qualityLevels);

  // Include the version number.
  qualityLevels.VERSION = version;

  return qualityLevels;

}));


/***/ }),

/***/ 736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var video_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21838);
/* harmony import */ var global_document__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34153);
/* harmony import */ var global_document__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(global_document__WEBPACK_IMPORTED_MODULE_1__);
/*! @name videojs-errors @version 6.2.0 @license Apache-2.0 */



var version = "6.2.0";

const merge = video_js__WEBPACK_IMPORTED_MODULE_0__["default"].obj && video_js__WEBPACK_IMPORTED_MODULE_0__["default"].obj.merge || video_js__WEBPACK_IMPORTED_MODULE_0__["default"].mergeOptions;
const defaultDismiss = !video_js__WEBPACK_IMPORTED_MODULE_0__["default"].browser.IS_IPHONE; // Default options for the plugin.

const defaults = {
  header: '',
  code: '',
  message: '',
  timeout: 45 * 1000,
  backgroundTimeout: 300 * 1000,
  dismiss: defaultDismiss,
  errors: {
    '1': {
      type: 'MEDIA_ERR_ABORTED',
      headline: 'The video download was cancelled'
    },
    '2': {
      type: 'MEDIA_ERR_NETWORK',
      headline: 'The video connection was lost, please confirm you are ' + 'connected to the internet'
    },
    '3': {
      type: 'MEDIA_ERR_DECODE',
      headline: 'The video is bad or in a format that cannot be played on your browser'
    },
    '4': {
      type: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
      headline: 'This video is either unavailable or not supported in this browser'
    },
    '5': {
      type: 'MEDIA_ERR_ENCRYPTED',
      headline: 'The video you are trying to watch is encrypted and we do not know how ' + 'to decrypt it'
    },
    'unknown': {
      type: 'MEDIA_ERR_UNKNOWN',
      headline: 'An unanticipated problem was encountered, check back soon and try again'
    },
    '-1': {
      type: 'PLAYER_ERR_NO_SRC',
      headline: 'No video has been loaded'
    },
    '-2': {
      type: 'PLAYER_ERR_TIMEOUT',
      headline: 'It looks like you\'re having playback issues. Reloading the video may help.'
    },
    'PLAYER_ERR_DOMAIN_RESTRICTED': {
      headline: 'This video is restricted from playing on your current domain'
    },
    'PLAYER_ERR_IP_RESTRICTED': {
      headline: 'This video is restricted at your current IP address'
    },
    'PLAYER_ERR_GEO_RESTRICTED': {
      headline: 'This video is restricted from playing in your current geographic region'
    }
  }
};

const initPlugin = function (player, options) {
  let monitor;
  let waiting;
  let isStalling;
  const listeners = [];

  const updateErrors = function (updates) {
    options.errors = merge(options.errors, updates); // Create `code`s from errors which don't have them (based on their keys).

    Object.keys(options.errors).forEach(k => {
      const err = options.errors[k];

      if (!err.type) {
        err.type = k;
      }
    });
  }; // Make sure we flesh out initially-provided errors.


  updateErrors(); // clears the previous monitor timeout and sets up a new one

  const resetMonitor = function () {
    // clear out any existing player error now that playback has recovered
    if (player.error() && player.error().code === -2) {
      player.error(null);
    }

    player.clearTimeout(waiting);
    player.clearTimeout(monitor);

    if (isStalling) {
      isStalling = false;
      player.removeClass('vjs-waiting');
    } // Disable timeouts in the background altogether according to the backgroundTimeout
    // option, or if the player is muted, as browsers may throttle javascript timers to
    // 1 minute in that case


    const disableValues = [Infinity, -1];

    const disableValueMatch = (valArray, option) => valArray.indexOf(option) !== -1;

    if ((global_document__WEBPACK_IMPORTED_MODULE_1___default().visibilityState) === 'hidden' && (player.muted() || disableValueMatch(disableValues, options.backgroundTimeout)) || (global_document__WEBPACK_IMPORTED_MODULE_1___default().visibilityState) === 'visible' && disableValueMatch(disableValues, options.timeout)) {
      return;
    } // start the loading spinner if player has stalled


    waiting = player.setTimeout(function () {
      // player already has an error
      // or is not playing under normal conditions
      if (player.error() || player.paused() || player.ended()) {
        return;
      }

      isStalling = true;
      player.addClass('vjs-waiting');
    }, 1000);
    monitor = player.setTimeout(function () {
      // player already has an error
      // or is not playing under normal conditions
      if (player.error() || player.paused() || player.ended()) {
        return;
      }

      player.error({
        code: -2,
        type: 'PLAYER_ERR_TIMEOUT'
      });
    }, (global_document__WEBPACK_IMPORTED_MODULE_1___default().visibilityState) === 'hidden' ? options.backgroundTimeout : options.timeout);
  }; // clear any previously registered listeners


  const cleanup = function () {
    let listener;

    while (listeners.length) {
      listener = listeners.shift();
      player.off(listener[0], listener[1]);
    }

    player.clearTimeout(monitor);
    player.clearTimeout(waiting);
  }; // creates and tracks a player listener if the player looks alive


  const healthcheck = function (type, fn) {
    const check = function () {
      // if there's an error do not reset the monitor and
      // clear the error unless time is progressing
      if (!player.error()) {
        // playback isn't expected if the player is paused
        if (player.paused()) {
          return resetMonitor();
        } // playback isn't expected once the video has ended


        if (player.ended()) {
          return resetMonitor();
        }
      }

      fn.call(this);
    };

    player.on(type, check);
    listeners.push([type, check]);
  };

  const onPlayStartMonitor = function () {
    let lastTime = 0;
    cleanup(); // if no playback is detected for long enough, trigger a timeout error

    resetMonitor();
    healthcheck(['timeupdate', 'adtimeupdate'], function () {
      const currentTime = player.currentTime(); // playback is operating normally or has recovered

      if (currentTime !== lastTime) {
        lastTime = currentTime;
        resetMonitor();
      }
    }); // Restart timeout monitor when the document transitions between the
    // foreground and background

    player.off((global_document__WEBPACK_IMPORTED_MODULE_1___default()), 'visibilitychange', onPlayStartMonitor);
    player.on((global_document__WEBPACK_IMPORTED_MODULE_1___default()), 'visibilitychange', onPlayStartMonitor);
  };

  const onPlayNoSource = function () {
    if (!player.currentSrc()) {
      player.error({
        code: -1,
        type: 'PLAYER_ERR_NO_SRC'
      });
    }
  };

  const onErrorHandler = function () {
    let details = '';
    let error = player.error();
    const content = global_document__WEBPACK_IMPORTED_MODULE_1___default().createElement('div');
    let dialogContent = ''; // In the rare case when `error()` does not return an error object,
    // defensively escape the handler function.

    if (!error) {
      return;
    } // Stop restarting the monitor on visibilitychanges now that an error has occurred


    player.off((global_document__WEBPACK_IMPORTED_MODULE_1___default()), 'visibilitychange', onPlayStartMonitor);
    error = merge(error, options.errors[error.code || error.type || 0]);

    if (error.message) {
      details = `<div class="vjs-errors-details">${player.localize('Technical details')}
        : <div class="vjs-errors-message">${player.localize(error.message)}</div>
        </div>`;
    }

    const display = player.getChild('errorDisplay');
    content.className = 'vjs-errors-dialog';
    const errorCode = `<div class="vjs-errors-code"><b>${this.localize('Error Code')}:</b> ${error.type || error.code}</div>`;
    const isTimeoutError = error.code === -2;
    dialogContent = `<div class="vjs-errors-content-container">
        <h2 class="vjs-errors-headline">${this.localize(error.headline)}</h2>
        ${isTimeoutError ? '' : errorCode}
        ${isTimeoutError ? '' : details}
      </div>`;
    const closeable = display.closeable(!('dismiss' in error) || error.dismiss);

    if (isTimeoutError) {
      dialogContent += `<div class="vjs-errors-timeout-button-container">
         <button>${this.localize('Reload Video')}</button>
         <button>${this.localize('Dismiss')}</button>
       </div>`;
      content.innerHTML = dialogContent;
      display.fillWith(content);
      display.getChild('closeButton').hide();
      const reloadButton = display.el().querySelector('.vjs-errors-timeout-button-container > button:first-child');
      const dismissButton = display.el().querySelector('.vjs-errors-timeout-button-container > button:last-child');

      const reloadHandler = () => {
        const source = player.currentSource();
        player.reset();
        player.src(source);
      };

      player.on(reloadButton, 'click', reloadHandler);
      display.one('modalclose', () => {
        player.off(reloadButton, 'click', reloadHandler);
        player.off(dismissButton, 'click', display.close);
      });
    } else if (closeable) {
      // We should get a close button
      dialogContent += `<div class="vjs-errors-ok-button-container">
          <button class="vjs-errors-ok-button">${this.localize('OK')}</button>
        </div>`;
      content.innerHTML = dialogContent;
      display.fillWith(content); // Get the close button inside the error display

      display.contentEl().firstChild.appendChild(display.getChild('closeButton').el());
      const okButton = display.el().querySelector('.vjs-errors-ok-button');
      player.on(okButton, 'click', function () {
        display.close();
      });
    } else {
      content.innerHTML = dialogContent;
      display.fillWith(content);
    }

    if (player.currentWidth() <= 600 || player.currentHeight() <= 250) {
      display.addClass('vjs-xs');
    }

    display.one('modalclose', () => player.error(null));
  };

  const onDisposeHandler = function () {
    cleanup();
    player.removeClass('vjs-errors');
    player.off('play', onPlayStartMonitor);
    player.off((global_document__WEBPACK_IMPORTED_MODULE_1___default()), 'visibilitychange', onPlayStartMonitor);
    player.off('play', onPlayNoSource);
    player.off('dispose', onDisposeHandler);
    player.off(['aderror', 'error'], onErrorHandler);
  };

  const reInitPlugin = function (newOptions) {
    onDisposeHandler();
    initPlugin(player, merge(defaults, newOptions));
  };

  reInitPlugin.extend = errors => updateErrors(errors);

  reInitPlugin.getAll = () => merge(options.errors); // Get / set timeout value. Restart monitor if changed.


  reInitPlugin.timeout = function (timeout) {
    if (typeof timeout === 'undefined') {
      return options.timeout;
    }

    if (timeout !== options.timeout) {
      options.timeout = timeout;

      if (!player.paused()) {
        onPlayStartMonitor();
      }
    }
  }; // Get / set backgroundTimeout value. Restart monitor if changed.


  reInitPlugin.backgroundTimeout = function (timeout) {
    if (typeof timeout === 'undefined') {
      return options.backgroundTimeout;
    }

    if (timeout !== options.backgroundTimeout) {
      options.backgroundTimeout = timeout;

      if (!player.paused()) {
        onPlayStartMonitor();
      }
    }
  }; // no-op API
  // TODO: remove in a major version


  reInitPlugin.disableProgress = () => {};

  player.on('play', onPlayStartMonitor);
  player.on('play', onPlayNoSource);
  player.on('dispose', onDisposeHandler);
  player.on(['aderror', 'contenterror', 'error'], onErrorHandler);
  player.ready(() => {
    player.addClass('vjs-errors');
  }); // if the plugin is re-initialised during playback, start the timeout handler.

  if (!player.paused()) {
    onPlayStartMonitor();
  } // Include the version number.


  reInitPlugin.VERSION = version;
  player.errors = reInitPlugin;
};

const errors = function (options) {
  initPlugin(this, merge(defaults, options));
};

['extend', 'getAll'].forEach(k => {
  errors[k] = function () {
    video_js__WEBPACK_IMPORTED_MODULE_0__["default"].log.warn(`The errors.${k}() method is not available until the plugin has been initialized!`);
  };
}); // Include the version number.

errors.VERSION = version; // Register the plugin with video.js.

video_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerPlugin('errors', errors);




/***/ }),

/***/ 22901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*! @name videojs-hls-quality-selector @version 2.0.0 @license MIT */
(function (global, factory) {
   true ? module.exports = factory(__webpack_require__(21838)) :
  0;
}(this, (function (videojs) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var videojs__default = /*#__PURE__*/_interopDefaultLegacy(videojs);

  var version = "2.0.0";

  const MenuButton = videojs__default['default'].getComponent('MenuButton');
  const Menu = videojs__default['default'].getComponent('Menu');
  const Component = videojs__default['default'].getComponent('Component');
  const Dom = videojs__default['default'].dom;

  /**
   * Convert string to title case.
   *
   * @param {string} string - the string to convert
   * @return {string} the returned titlecase string
   */
  function toTitleCase(string) {
    if (typeof string !== 'string') {
      return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * Extend vjs button class for quality button.
   */
  class ConcreteButton extends MenuButton {
    /**
     * Button constructor.
     *
     * @param {Player} player - videojs player instance
     */
    constructor(player) {
      super(player, {
        title: player.localize('Quality'),
        name: 'QualityButton'
      });
    }

    /**
     * Creates button items.
     *
     * @return {Array} - Button items
     */
    createItems() {
      return [];
    }

    /**
     * Create the menu and add all items to it.
     *
     * @return {Menu}
     *         The constructed menu
     */
    createMenu() {
      const menu = new Menu(this.player_, {
        menuButton: this
      });
      this.hideThreshold_ = 0;

      // Add a title list item to the top
      if (this.options_.title) {
        const titleEl = Dom.createEl('li', {
          className: 'vjs-menu-title',
          innerHTML: toTitleCase(this.options_.title),
          tabIndex: -1
        });
        const titleComponent = new Component(this.player_, {
          el: titleEl
        });
        this.hideThreshold_ += 1;
        menu.addItem(titleComponent);
      }
      this.items = this.createItems();
      if (this.items) {
        // Add menu items to the menu
        for (let i = 0; i < this.items.length; i++) {
          menu.addItem(this.items[i]);
        }
      }
      return menu;
    }
  }

  // Concrete classes
  const VideoJsMenuItemClass = videojs__default['default'].getComponent('MenuItem');

  /**
   * Extend vjs menu item class.
   */
  class ConcreteMenuItem extends VideoJsMenuItemClass {
    /**
     * Menu item constructor.
     *
     * @param {Player} player - vjs player
     * @param {Object} item - Item object
     * @param {ConcreteButton} qualityButton - The containing button.
     * @param {HlsQualitySelector} plugin - This plugin instance.
     */
    constructor(player, item, qualityButton, plugin) {
      super(player, {
        label: item.label,
        selectable: true,
        selected: item.selected || false
      });
      this.item = item;
      this.qualityButton = qualityButton;
      this.plugin = plugin;
    }

    /**
     * Click event for menu item.
     */
    handleClick() {
      // Reset other menu items selected status.
      for (let i = 0; i < this.qualityButton.items.length; ++i) {
        this.qualityButton.items[i].selected(false);
      }

      // Set this menu item to selected, and set quality.
      this.plugin.setQuality(this.item.value);
      this.selected(true);
    }
  }

  const Plugin = videojs__default['default'].getPlugin('plugin');

  // Default options for the plugin.
  const defaults = {};

  /**
   * An advanced Video.js plugin. For more information on the API
   *
   * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
   */
  class HlsQualitySelector extends Plugin {
    /**
     * Create a HlsQualitySelector plugin instance.
     *
     * @param  {Player} player
     *         A Video.js Player instance.
     *
     * @param  {Object} [options]
     *         An optional options object.
     *
     *         While not a core part of the Video.js plugin architecture, a
     *         second argument of options is a convenient way to accept inputs
     *         from your plugin's caller.
     */
    constructor(player, options) {
      // the parent class will add player under this.player
      super(player);
      this.options = videojs__default['default'].obj.merge(defaults, options);
      this.player.ready(() => {
        // If there is quality levels plugin and the HLS tech exists then continue.
        if (this.player.qualityLevels) {
          this.player.addClass('vjs-hls-quality-selector');
          // Create the quality button.
          this.createQualityButton();
          this.bindPlayerEvents();
        }
      });
    }

    /**
     * Binds listener for quality level changes.
     */
    bindPlayerEvents() {
      this.player.qualityLevels().on('addqualitylevel', this.onAddQualityLevel.bind(this));
    }

    /**
     * Adds the quality menu button to the player control bar.
     */
    createQualityButton() {
      const player = this.player;
      this._qualityButton = new ConcreteButton(player);
      const placementIndex = player.controlBar.children().length - 2;
      const concreteButtonInstance = player.controlBar.addChild(this._qualityButton, {
        componentClass: 'qualitySelector'
      }, this.options.placementIndex || placementIndex);
      concreteButtonInstance.addClass('vjs-quality-selector');
      if (!this.options.displayCurrentQuality) {
        const icon = ` ${this.options.vjsIconClass || 'vjs-icon-hd'}`;
        concreteButtonInstance.menuButton_.$('.vjs-icon-placeholder').className += icon;
      } else {
        this.setButtonInnerText(player.localize('Auto'));
      }
      concreteButtonInstance.removeClass('vjs-hidden');
    }

    /**
     *Set inner button text.
     *
     * @param {string} text - the text to display in the button.
     */
    setButtonInnerText(text) {
      this._qualityButton.menuButton_.$('.vjs-icon-placeholder').innerHTML = text;
    }

    /**
     * Builds individual quality menu items.
     *
     * @param {Object} item - Individual quality menu item.
     * @return {ConcreteMenuItem} - Menu item
     */
    getQualityMenuItem(item) {
      const player = this.player;
      return new ConcreteMenuItem(player, item, this._qualityButton, this);
    }

    /**
     * Executed when a quality level is added from HLS playlist.
     */
    onAddQualityLevel() {
      const player = this.player;
      const qualityList = player.qualityLevels();
      const levels = qualityList.levels_ || [];
      const levelItems = [];
      for (let i = 0; i < levels.length; ++i) {
        const {
          width,
          height
        } = levels[i];
        const pixels = width > height ? height : width;
        if (!pixels) {
          continue;
        }
        if (!levelItems.filter(_existingItem => {
          return _existingItem.item && _existingItem.item.value === pixels;
        }).length) {
          const levelItem = this.getQualityMenuItem.call(this, {
            label: pixels + 'p',
            value: pixels
          });
          levelItems.push(levelItem);
        }
      }
      levelItems.sort((current, next) => {
        if (typeof current !== 'object' || typeof next !== 'object') {
          return -1;
        }
        if (current.item.value < next.item.value) {
          return -1;
        }
        if (current.item.value > next.item.value) {
          return 1;
        }
        return 0;
      });
      levelItems.push(this.getQualityMenuItem.call(this, {
        label: this.player.localize('Auto'),
        value: 'auto',
        selected: true
      }));
      if (this._qualityButton) {
        this._qualityButton.createItems = () => {
          return levelItems;
        };
        this._qualityButton.update();
      }
    }

    /**
     * Sets quality (based on media short side)
     *
     * @param {number} quality - A number representing HLS playlist.
     */
    setQuality(quality) {
      const qualityList = this.player.qualityLevels();

      // Set quality on plugin
      this._currentQuality = quality;
      if (this.options.displayCurrentQuality) {
        this.setButtonInnerText(quality === 'auto' ? this.player.localize('Auto') : `${quality}p`);
      }
      for (let i = 0; i < qualityList.length; ++i) {
        const {
          width,
          height
        } = qualityList[i];
        const pixels = width > height ? height : width;
        qualityList[i].enabled = pixels === quality || quality === 'auto';
      }
      this._qualityButton.unpressButton();
    }

    /**
     * Return the current set quality or 'auto'
     *
     * @return {string} the currently set quality
     */
    getCurrentQuality() {
      return this._currentQuality || 'auto';
    }
  }

  // Include the version number.
  HlsQualitySelector.VERSION = version;

  // Register the plugin with video.js.
  videojs__default['default'].registerPlugin('hlsQualitySelector', HlsQualitySelector);

  return HlsQualitySelector;

})));


/***/ }),

/***/ 6256:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*! @name videojs-sprite-thumbnails @version 2.2.3 @license MIT */
(function (global, factory) {
   true ? module.exports = factory(__webpack_require__(21838)) :
  0;
})(this, (function (videojs) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var videojs__default = /*#__PURE__*/_interopDefaultLegacy(videojs);

  /**
   * Set up sprite thumbnails for a player.
   *
   * @function spriteThumbs
   * @param {Player} player
   *        The current player instance.
   * @param {Plugin} plugin
   *        The current spriteThumbnails plugin instance.
   * @param {Object} options
   *        Plugin configuration options.
   */
  const spriteThumbs = (player, plugin, options) => {
    const navigator = window.navigator;
    const dom = videojs__default["default"].dom;
    const obj = videojs__default["default"].obj;
    const log = plugin.log;
    const debug = log.debug;
    const defaultState = {
      ...plugin.state
    };
    const setDefaultState = () => {
      plugin.setState(defaultState);
    };

    // default control bar component tree is expected
    // https://docs.videojs.com/tutorial-components.html#default-component-tree
    const descendants = ['ControlBar', 'ProgressControl', 'SeekBar', 'MouseTimeDisplay', 'TimeTooltip'];
    const [_controlBar, _progressControl, _seekBar,

      // no need to assign MouseTimeDisplay
    , _timeTooltip] = descendants;
    const playerDescendant = componentName => {
      const idx = descendants.indexOf(componentName);
      const component = player.getDescendant(descendants.slice(0, idx + 1));
      if (!component) {
        setDefaultState();
        debug(`component tree ${descendants.join(' > ')} required`);
      }
      return component;
    };
    let tooltipEl;
    let tooltipStyleOrig;
    const getUrl = idx => {
      const urlArray = options.urlArray;
      return urlArray.length ? urlArray[idx] : options.url.replace('{index}', options.idxTag(idx));
    };
    const hijackMouseTooltip = evt => {
      if (!playerDescendant(_timeTooltip)) {
        return;
      }
      const seekBarEl = playerDescendant(_seekBar).el();
      const controlsTop = dom.findPosition(playerDescendant(_controlBar).el()).top;
      const playerWidth = player.currentWidth();
      const duration = player.duration();
      const interval = options.interval;
      const columns = options.columns;
      const responsive = options.responsive;
      const rowDuration = interval * columns;
      // spriteDuration is needed to calculate idx
      const spriteDuration = rowDuration * (options.rows || Math.ceil(duration / rowDuration));
      let position = dom.getPointerPosition(seekBarEl, evt).x * duration;
      // for single sprites idx is always 0
      const idx = Math.floor(position / spriteDuration);

      // if (idx == 0) position /= interval
      position = (position - spriteDuration * idx) / interval;
      const scaleFactor = responsive && playerWidth < responsive ? playerWidth / responsive : 1;
      const scaledWidth = options.width * scaleFactor;
      const scaledHeight = options.height * scaleFactor;
      const cleft = Math.floor(position % columns) * -scaledWidth;
      const ctop = Math.floor(position / columns) * -scaledHeight;
      const seekBarTop = dom.findPosition(seekBarEl).top;
      // top of seekBar is 0 position
      const topOffset = -scaledHeight - Math.max(0, seekBarTop - controlsTop);
      const tooltipStyle = {
        backgroundImage: `url("${getUrl(idx)}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: `${cleft}px ${ctop}px`,
        backgroundSize: `${scaledWidth * columns}px auto`,
        top: `${topOffset}px`,
        color: '#fff',
        textShadow: '1px 1px #000',
        // box-sizing: border-box inherited from .video-js
        border: '1px solid #000',
        // border should not overlay thumbnail area
        width: `${scaledWidth + 2}px`,
        height: `${scaledHeight + 2}px`
      };
      obj.each(tooltipStyle, (value, key) => {
        tooltipEl.style[key] = value;
      });
    };
    const intCheck = opt => {
      const val = options[opt];
      const min = opt !== 'rows' ? 1 : 0;
      const check = parseInt(val, 10) === val && val >= min;
      if (!check) {
        log.warn(`${opt} must be an integer greater than ${min - 1}`);
      }
      return check;
    };
    const downlinkCheck = () => {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const dl = 'downlink';
      const check = !connection || connection[dl] >= options[dl];
      if (!check) {
        log(`connection.${dl} < ${options[dl]}`);
      }
      return check;
    };
    const handleStateChanged = evt => {
      const pstate = plugin.state;
      const spriteEvents = ['mousemove', 'touchmove'];
      const progress = playerDescendant(_progressControl);
      if (pstate.ready) {
        debug('ready to show thumbnails');
        progress.on(spriteEvents, hijackMouseTooltip);
      } else {
        if (!options.url && !options.urlArray.length) {
          debug('no urls given, resetting');
        }
        if (progress) {
          progress.off(spriteEvents, hijackMouseTooltip);
          tooltipEl.style = tooltipStyleOrig;
        }
      }
      player.toggleClass('vjs-thumbnails-ready', pstate.ready);
    };
    const init = evt => {
      // `loadstart` callback is only needed when all of the following apply:
      // - player is set up to load an initial video via `src` or `loadMedia`
      //   specifying a `spriteThumbnails` config object
      // - the player is told e.g. by user action to load a different video `src`
      //   or `loadMedia` before metadata of the initial video is loaded and its
      //   `spriteThumbnails` options cannot be merged
      // Thereafter the `loadstart` callback is redundant.
      player.off('loadstart', init);

      // clean slate
      setDefaultState();

      // if present, merge source config with current config
      const plugName = plugin.name;
      const thumbSource = player.currentSources().find(source => {
        return source.hasOwnProperty(plugName);
      });
      let srcOpts = thumbSource && thumbSource[plugName];
      if (srcOpts) {
        // empty config unsets url and urlArray
        // force urlArray or url according to precedence
        const urlArray = srcOpts.urlArray;
        if (!Object.keys(srcOpts).length) {
          srcOpts = {
            url: '',
            urlArray: []
          };
        } else if (urlArray && urlArray.length) {
          srcOpts.url = '';
        } else if (srcOpts.url) {
          srcOpts.urlArray = [];
        }
        plugin.options = options = obj.merge(options, srcOpts);
      }
      const mouseTimeTooltip = playerDescendant(_timeTooltip);
      if (!mouseTimeTooltip || evt.type === 'loadstart') {
        return;
      }
      tooltipEl = mouseTimeTooltip.el();
      tooltipStyleOrig = tooltipEl.style;
      plugin.setState({
        ready: !!((options.urlArray.length || options.url) && intCheck('width') && intCheck('height') && intCheck('columns') && intCheck('rows') && downlinkCheck())
      });
    };
    plugin.on('statechanged', handleStateChanged);
    player.on(['loadstart', 'loadedmetadata'], init);
    player.addClass('vjs-sprite-thumbnails');
  };

  var version = "2.2.3";

  const Plugin = videojs__default["default"].getPlugin('plugin');

  /**
   * Default plugin options
   *
   * @param {String} url
   *        Location of image(s). Must be set by user. For multiple images the
   *        filename must contain the template {index} which is replaced by the
   *        zero based index number of the image in the sequence. Default: ''.
   * @param {Array} urlArray
   *        Array of image locations. Default: [].
   * @param {Integer} width
   *        Width of a thumbnail in pixels. Must be set by user. Default: 0.
   * @param {Integer} height
   *        Height of a thumbnail in pixels. Must be set by user. Default: 0.
   * @param {Integer} columns
   *        Number of thumbnail columns per image. Must be set by user.
   * @param {Integer} rows
   *        Number of thumbnail rows per image. If set to greater than 0, the
   *        plugin will expect a sequence of images. Default: 0.
   * @param {Number} interval
   *        Interval between thumbnail frames in seconds. Default: 1.
   * @param {Function} idxTag
   *        Function determining the substitiuton of the {index} template in the
   *        current url. Default: returns index as is.
   * @param {Integer} responsive
   *        Width of player below which thumbnails are reponsive. Default: 600.
   * @param {Number} downlink
   *        Minimum of NetworkInformation downlink where supported. Default: 1.5.
   *        https://developer.mozilla.org/docs/Web/API/NetworkInformation/downlink
   */
  const defaults = {
    url: '',
    idxTag(i) {
      return i;
    },
    urlArray: [],
    width: 0,
    height: 0,
    columns: 0,
    rows: 0,
    interval: 1,
    responsive: 600,
    downlink: 1.5
  };

  /**
   * An advanced Video.js plugin. For more information on the API
   *
   * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
   */
  class SpriteThumbnails extends Plugin {
    /**
     * Create a SpriteThumbnails plugin instance.
     *
     * @param  {Player} player
     *         A Video.js Player instance.
     *
     * @param  {Object} [options]
     *         An optional options object.
     */
    constructor(player, options) {
      // the parent class will add player under this.player
      super(player, options);
      this.options = videojs__default["default"].obj.merge(defaults, options);
      this.player.ready(() => {
        spriteThumbs(this.player, this, this.options);
      });
    }
  }

  // Define default values for the plugin's `state` object here.
  SpriteThumbnails.defaultState = {
    ready: false
  };

  // Include the version number.
  SpriteThumbnails.VERSION = version;

  // Register the plugin with video.js.
  videojs__default["default"].registerPlugin('spriteThumbnails', SpriteThumbnails);

  return SpriteThumbnails;

}));


/***/ })

}]);